import { render, staticRenderFns } from "./AudioList.vue?vue&type=template&id=daf14048&scoped=true"
import script from "./AudioList.vue?vue&type=script&lang=js"
export * from "./AudioList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf14048",
  null
  
)

export default component.exports